import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/apiClient";
import { ProductCard } from "../components/ProductCard";

export default function CategoryPage() {
  const { slug } = useParams();
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      api.get(`/products?category=${slug}`),
      api.get("/categories"),
    ]).then(([p, c]) => {
      setProducts(p.data);
      setCategory(c.data.find((x) => x.slug === slug) || null);
      setLoading(false);
    });
  }, [slug]);

  return (
    <div data-testid="category-page" className="min-h-[60vh]">
      {/* header */}
      <section className="relative h-[42vh] min-h-[300px] overflow-hidden">
        <img src={category?.image} alt={category?.name} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative h-full mx-auto max-w-7xl px-6 md:px-12 flex flex-col justify-end pb-12">
          <div className="text-xs tracking-[0.25em] uppercase font-bold text-white/70 mb-3">Category</div>
          <h1 className="font-display text-5xl sm:text-7xl tracking-tighter font-black uppercase text-white">{category?.name || slug}</h1>
          {category?.description && <p className="text-white/80 mt-3 max-w-xl">{category.description}</p>}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 md:px-12 py-16">
        <div className="text-sm text-zinc-500 mb-8" data-testid="category-count">{products.length} product{products.length !== 1 ? "s" : ""}</div>
        {loading ? (
          <p className="text-zinc-400">Loading…</p>
        ) : products.length === 0 ? (
          <p className="text-zinc-400" data-testid="category-empty">No products in this category yet.</p>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
            {products.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
